var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0137 1.63585C14.0137 1.27686 13.7227 0.985847 13.3637 0.985848L7.51367 0.985848C7.15468 0.985847 6.86367 1.27686 6.86367 1.63585C6.86366 1.99483 7.15468 2.28585 7.51366 2.28585L12.7137 2.28585L12.7137 7.48585C12.7137 7.84483 13.0047 8.13585 13.3637 8.13585C13.7227 8.13585 14.0137 7.84483 14.0137 7.48585L14.0137 1.63585ZM1.09536 14.8234L13.8233 2.09547L12.904 1.17623L0.176123 13.9042L1.09536 14.8234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.b63f30cbda63b902a6b789f59e7fbac0.svg";
export { ForwardRef as ReactComponent };